<template>
  <el-drawer
    :title="drawerTitle"
    :visible.sync="drawerVisible"
    direction="rtl"
    @close="handleDrawerClose"
    :modal="false"
  >
    <div v-if="selectedContact" class="role-details">
      <div class="detail-item">
        <label>Nombre:</label>
        <span>{{ selectedContact.FullName }}</span>
      </div>
      <div class="detail-item">
        <label>Email:</label>
        <span>{{ selectedContact.Email }}</span>
      </div>
      <div class="detail-item">
        <label>Role:</label>
        <span
          :style="{
            color: getRoleColor(selectedContact.User?.Roles),
            fontWeight: 'bold'
          }"
          >{{ selectedContact.User?.Roles?.toUpperCase() || "NO ROLES" }}</span
        >
      </div>
      <div class="detail-item">
        <label>Teléfono:</label>
        <span>{{ selectedContact.PhoneNumber || "-" }}</span>
      </div>
      <div class="detail-item">
        <label>Celular:</label>
        <span>{{ selectedContact.MobilePhoneNumber || "-" }}</span>
      </div>
      <div class="detail-item">
        <label>Acciones del Role:</label>
        <div class="actions" v-if="roleActionsList.length">
          <ol>
            <li v-for="(action, index) in roleActionsList" :key="index">
              {{ action }}
            </li>
          </ol>
        </div>
      </div>
      <div style="padding-top: 20px">
        <el-button type="primary" @click="handleActiveUser(selectedContact)"
          >{{ textActive
          }}<i
            class="el-icon-active el-icon-right"
            style="padding-left: 8px"
          ></i
        ></el-button>
        <el-button
          :disabled="!selectedContact.HasPortal"
          type="primary"
          @click="handleAsignedRole"
          >{{ textAsignedRole
          }}<i class="el-icon-user el-icon-right" style="padding-left: 8px"></i
        ></el-button>
      </div>
    </div>

    <el-dialog
      title="Asignar Role"
      :visible.sync="openAsignedRole"
      width="30%"
      append-to-body
      @close="handleDialogClose"
    >
      <el-checkbox-group v-model="checkRole" :min="0" :max="1">
        <el-checkbox
          v-for="role in roles"
          :label="role.value"
          :key="role.value"
        >
          {{ role.label }}
        </el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="openAsignedRole = false">Cancelar</el-button>
        <el-button type="primary" @click="handleSaveRole(selectedContact)"
          >Guardar</el-button
        >
      </span>
    </el-dialog>
  </el-drawer>
</template>

<script>
const roleOptions = [
  { value: "7E897E58-0BEC-456F-B96C-605472DE8999", label: "Basico" },
  { value: "5AA6C787-6FF3-4AAC-9C24-C0A43F79832D", label: "Tecnico" },
  { value: "2BE71C23-E961-49C4-91F8-D9E5E01F65D2", label: "Financiero" },
  { value: "2D4A0C55-5A5F-4363-86EB-EA1DF7FDFA78", label: "Admin" }
];

export default {
  name: "ContactsViewRol",
  props: {
    selectedContact: {
      type: Object,
      required: false
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      openAsignedRole: false,
      checkRole: [],
      roles: roleOptions,
      rolActions: [
        {
          value: "Basico",
          actionsRol: ["Gestión de solicitudes", "Gestión de reclamaciones"]
        },
        {
          value: "Tecnico",
          actionsRol: [
            "Gestión de solicitudes",
            "Gestión de reclamaciones",
            "Registrar solicitudes desde contratos"
          ]
        },
        {
          value: "Financiero",
          actionsRol: [
            "Gestión de solicitudes",
            "Gestión de reclamaciones",
            "Registrar solicitudes desde contratos",
            "Ver estados de cuenta"
          ]
        },
        {
          value: "Admin",
          actionsRol: [
            "Gestión de solicitudes",
            "Gestión de reclamaciones",
            "Registrar solicitudes desde contratos",
            "Ver estados de cuenta",
            "Gestión de usuarios"
          ]
        }
      ]
    };
  },
  methods: {
    getRoleColor(role) {
      const colorMap = {
        Admin: "#67C23A",
        Basico: "#409EFF",
        Financiero: "#E6A23C",
        Tecnico: "#909399",
        "NO ROLES": "#F56C6C"
      };
      return colorMap[role] || "#909399";
    },
    handleDrawerClose() {
      this.$emit("close");
      this.$emit("update:visible", false);
    },
    handleActiveUser(contact) {
      this.$confirm(
        `¿Estás seguro de que deseas ${
          contact?.HasPortal === true ? "desactivar" : "activar"
        } este usuario?`,
        "Confirmar Acción",
        {
          confirmButtonText: "Sí",
          cancelButtonText: "No",
          type: "warning"
        }
      )
        .then(() => {
          this.toggleUserActive(contact);
        })
        .catch(() => {
          // Acción cancelada
        });
    },
    async toggleUserActive(contact) {
      if (contact.User?.Id == null || contact.User == null) {
        const params = {
          Email: contact.Email,
          PhoneNunber: contact.PhoneNumber,
          customerCode: contact.CustomerCode,
          companyCode: contact.CompanyId
        };

        const response = await this.$http.post(
          "/api/contacts/createUserInMagynetFromPortal",
          params
        );
        if (response.status === 200) {
          this.$message.success("Usuario creado y activado correctamente");
        } else {
          this.$message.error("Error al crear y activar el usuario");
        }
        this.$emit("toggle-active", contact);
        this.handleDrawerClose();
      } else {
        try {
          const userId = contact.User?.Id;
          const hasPortal = contact.HasPortal;
          const response = await this.$http.put(
            `/api/contacts/editUserInPortalFromMagynet?IdUser=${userId}&HasPortal=${!hasPortal}`
          );
          if (response.status === 200) {
            this.$message.success(
              !hasPortal
                ? "Usuario activado correctamente"
                : "Usuario desactivado correctamente"
            );
          }

          // Emitir evento para que el componente padre actualice la lista
          this.$emit("toggle-active", contact);
          this.handleDrawerClose();
        } catch (error) {
          this.$message.error(
            error.response?.data?.message ||
              "Error al cambiar el estado del usuario"
          );
        }
      }
    },
    handleAsignedRole() {
      this.openAsignedRole = true;
      // Cargar el rol actual del usuario si existe
      if (this.selectedContact?.User?.Roles) {
        const currentRole = this.roles.find(
          (r) => r.label === this.selectedContact.User.Roles
        );
        if (currentRole) {
          this.checkRole = [currentRole.value];
        } else {
          this.checkRole = [];
        }
      } else {
        this.checkRole = [];
      }
    },
    handleDialogClose() {
      this.checkRole = [];
    },
    async handleSaveRole(contact) {
      const Id = contact.User?.Id;
      const roleId = this.checkRole[0] || null;

      const responseApi = await this.$http.post(
        `/api/contacts/updateUserRoleInMagynetFromPortal?IdUser=${Id}&IdRole=${roleId}`
      );
      if (responseApi.status === 200) {
        this.$message.success("Rol actualizado correctamente");
      } else {
        this.$message.error("Error al actualizar el rol");
      }
      // if (this.checkRole.length > 0) {
      //   const selectedRole = this.roles.find(r => r.value === this.checkRole[0]);
      //   console.log("Rol seleccionado:", selectedRole);
      //   this.$emit("role-assigned", selectedRole);
      //   this.openAsignedRole = false;
      // } else {
      //   this.$message.warning('Por favor selecciona un rol');
      // }
      this.openAsignedRole = false;
      this.handleDrawerClose();
      this.$emit("toggle-active", contact);
    }
  },
  computed: {
    textActive() {
      return this.selectedContact?.HasPortal === true
        ? "Desactivar Usuario"
        : "Activar Usuario";
    },
    textAsignedRole() {
      return this.selectedContact?.User?.Roles ? "Editar Role" : "Asignar Role";
    },
    drawerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    },
    drawerTitle() {
      return "Detalles de Role";
    },
    roleActionsList() {
      if (!this.selectedContact?.User?.Roles) return [];
      const role = this.selectedContact.User.Roles;
      const roleAction = this.rolActions.find((r) => r.value === role);
      return roleAction ? roleAction.actionsRol : [];
    }
  }
};
</script>

<style lang="scss" scoped>
.role-details {
  width: 100%;
  max-width: none;
  padding: 20px 10px 20px 10px;
}

.detail-item {
  display: grid;
  grid-template-columns: 160px 1fr;
  gap: 12px 12px;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #ebeef5;
}

.detail-item label {
  font-weight: 600;
  color: #333;
  text-align: left;
}

.detail-item span {
  color: #606266;
  text-align: right;
  word-break: break-word;
}

@media (max-width: 600px) {
  .detail-item {
    grid-template-columns: 1fr;
  }

  .detail-item span {
    text-align: left;
    margin-top: 6px;
  }
}

.actions {
  text-align: right;
  padding: 0;
  justify-self: end;
}

.actions ol {
  margin: 0;
  padding: 0 8px 0 0;
  list-style-position: inside;
  list-style-type: decimal;
}

.actions li {
  padding: 2px 0;
  color: #606266;
  text-align: right;
}

.actions ol {
  width: 100%;
  padding-right: 0;
}
</style>
